import { LoggerLevel } from "@board/cloud-library/components/services";
import { EnvironmentInfo } from "./environment-interface";
import { ProductionPopupPublisher, ConsolePublisher } from "@board/cloud-library/components/publishers";
import { LocalStoragePublisher } from "src/app/core/logging/publishers/LocalStoragePublisher";

export const environment: EnvironmentInfo = {
  production: true,
  API: `${window.location.origin}/api`,
  authority: "https://boardb2c.b2clogin.com/account.board.com/B2C_1A_BOARD_DEMO_DEFAULT",
  clientId: "17504fd2-d37a-4e62-92bd-06fbe6dfad93",
  loggerConfig: {
    loggingLevel: LoggerLevel.WARN,
    publishers: [ConsolePublisher, LocalStoragePublisher, ProductionPopupPublisher]
  },
  appInsightsKey: "78ac2a4c-4a88-456d-ad88-4959b6d4c7c6",
  appInsightsConnectionString: undefined,
  apiScope: "https://account.board.com/17504fd2-d37a-4e62-92bd-06fbe6dfad93/access",
  hdpAddress: "https://datapipeline-training.board.com/"
};
